import { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '@/lib/supabase';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error: resetError } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    setLoading(false);
    if (resetError) {
      setError(resetError.message);
      return;
    }
    setSent(true);
  };

  return (
    <div className="min-h-screen bg-cream dark:bg-midnight-deep flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="card p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-gold to-gold-dark flex items-center justify-center">
              <i className="ri-lock-unlock-line text-midnight text-lg" />
            </div>
            <div>
              <h1 className="font-display text-xl font-bold text-foreground-950">Reset your password</h1>
              <p className="text-xs text-foreground-500">We'll email you a reset link</p>
            </div>
          </div>

          {sent ? (
            <div className="p-4 rounded-md bg-emerald-50 border border-emerald-200 text-sm text-emerald-800">
              If an account exists for <span className="font-medium">{email}</span>, a password reset
              link has been sent. Check your inbox.
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              {error && (
                <div className="p-3 rounded-md bg-red-50 border border-red-200 text-sm text-red-700">
                  {error}
                </div>
              )}
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  dir="ltr"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="you@example.com"
                  className="w-full px-4 py-3 text-sm rounded-xl border border-background-300 bg-surface dark:bg-midnight-card text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-gold focus:ring-2 focus:ring-gold/20 transition"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="btn-primary w-full h-12 flex items-center justify-center text-sm whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          )}

          <p className="mt-6 text-center text-sm text-foreground-500">
            <Link to="/login" className="inline-flex items-center gap-1 text-electric hover:underline font-medium transition">
              <i className="ri-arrow-left-line" /> Back to Sign In
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
